import React, { useState, useEffect } from "react";
import axiosClient from "../../axiosClient";
import { Box } from "@mui/material"; 

// Components
import HeroCarousel from "../components/HeroCarousel";
import Socialmedia from "../components/Socialmedia";
import Preloader from "../components/Preloader";

// Section Components
import SectionTwo from "./homesectioning/SectionTwo";
import SectionFour from "./homesectioning/SectionFour";
import SectionFive from "./homesectioning/SectionFive";
import SectionSix from "./homesectioning/Sectionsix";
import SectionSeven from "./homesectioning/SectionSeven";

const Index = () => {
  const [heroSlides, setHeroSlides] = useState([]);
  const [heroDefaults, setHeroDefaults] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const [slidesRes, defaultsRes] = await Promise.all([
          axiosClient.get('/hero-slides'),
          axiosClient.get('/hero-slides/defaults')
        ]);

        // --- Process Slides ---
        const slidesArray = slidesRes.data.data || [];

        if (Array.isArray(slidesArray)) {
          const mappedSlides = slidesArray.map((slide) => ({
            id: slide.id,
            title: slide.headline,
            subtitle: slide.subheadline,
            description: slide.body,
            layout: slide.layout_code,
            image: slide.bg_image_path,
            mobile_image: slide.fg_image_path,
            link_to: slide.cta_url,
            button_text: slide.cta_text,
            visibility: slide.visibility
          }));
          setHeroSlides(mappedSlides);
        }

        // --- Process Defaults ---
        setHeroDefaults(defaultsRes.data.data || defaultsRes.data || {});

      } catch (error) {
        console.error("Error loading home data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // --- LOADER SECTION ---
  if (loading) {
    return (
      <Box 
        sx={{ 
          // This keeps the footer pushed down to 85vh height
          // so it doesn't jump up while loading.
          height: { xs: "50vh", lg: "85vh" }, 
          width: "100%",
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center",
          position: "relative" 
        }}
      >
        <Preloader />
      </Box>
    );
  }

  return (
    <>
      <HeroCarousel slides={heroSlides} defaultBg={heroDefaults} />
      <SectionTwo />
      <Socialmedia />
      <SectionFour />
      <SectionFive />
      <SectionSix />
      <SectionSeven />
    </>
  );
};

export default Index;